import React, { Component } from "react";
import Grid from '../../components/grid';
import Loader from "../../components/loader";
import Axios from 'axios';
import permissionList from '../../assets/data/permissionList.json';

class ClientFunctionality extends Component {
    constructor(props) {
        super(props);
    }
    state = {
        loading: true,
        report: [],
        columnDefs: [
            {
                headerName: "Company Name",
                field: "companyName"
            },
            {
                headerName: "Short Name",
                field: "companyShortName"
            },
            ...[...permissionList].filter(el => el.portal === 'Client').map(el => {
                let { label, key } = el;
                return { headerName: label, field: key };
            })
        ]
    };

    getReport = async () => {
        let report = await Axios.get(`api/client-functionality/report`,).catch(e => e);
        return report?.data || [];
    };

    runReport = async () => {
        this.setState({ loading: true });
        let report = await this.getReport();
        return this.setState({ loading: false, report });
    };

    async componentDidMount() {
        let report = await this.getReport();
        this.setState({ loading: false, report });
    };

    render() {
        let { loading, report, columnDefs } = this.state;
        return (
            <>
                <div className="table-header d-flex  align-items-center justify-content-between">
                    <h4 className="heading_h4">Client Functionality Report <small>(Active Clients Only)</small></h4>
                    <div className="filter_inpt_sec position-relative date-range d-flex flex-wrap">

                    </div>
                    <button className="mla fs12 primary mini" onClick={this.runReport} disabled={loading}>
                        {loading ? <span>Loading data </span> : <span>Run Report</span>}
                    </button>
                </div>
                <div className="shadow_white_box full-box mt-0">
                    <div className="filter-list d-flex align-items-center justify-content-between">
                        <div className="filter-field d-flex">
                        </div>

                    </div>

                    {!loading ? <div className='loading-data'>
                        <Grid
                            enableRangeSelection={true}
                            rowData={report}
                            columnDefs={columnDefs}
                            height='600px'
                        >
                        </Grid>
                    </div> : <div className='loading-data d-flex align-items-center justify-content-center'> <Loader></Loader> </div>}


                </div>

            </>
        );
    }
}
export default ClientFunctionality;
